<template>
  <div :class="ns.b()" data-component-name="Empty" data-event-container="true">
    <div :class="ns.e('image')" :style="imageStyle">
      <img v-if="image" :src="image" ondragstart="return false" />
      <slot v-else name="image">
        <component :is="`${type}-empty`" />
      </slot>
    </div>
    <div :class="ns.e('description')">
      <slot v-if="$slots.description" name="description" />
      <p v-else>{{ emptyDescription }}</p>
    </div>
    <div v-if="$slots.default" :class="ns.e('bottom')">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useLocale, useNamespace } from '@jdesign-vue/hooks'
import { addUnit } from '@jdesign-vue/utils'
import DataEmpty from './data-empty.vue'
import SearchEmpty from './search-empty.vue'
import NewsEmpty from './news-empty.vue'
import PermissionEmpty from './permission-empty.vue'
import NetworkEmpty from './network-empty.vue'
import ServerEmpty from './server-empty.vue'
import BrowserEmpty from './browser-empty.vue'
import { emptyProps } from './empty'

import type { CSSProperties } from 'vue'

defineOptions({
  name: 'JdEmpty',
  components: {
    DataEmpty,
    SearchEmpty,
    NewsEmpty,
    PermissionEmpty,
    NetworkEmpty,
    ServerEmpty,
    BrowserEmpty,
  },
})

const props = defineProps(emptyProps)

const { t } = useLocale()
const ns = useNamespace('empty')
const emptyDescription = computed(
  () => props.description || t('el.table.emptyText')
)
const imageStyle = computed<CSSProperties>(() => ({
  width: addUnit(props.imageSize),
}))
</script>
